'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _prep = require('../internal/prep');

var _prep2 = _interopRequireDefault(_prep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (0, _prep2.default)({
    immutable: 'set',
    record: 'set',
    object: function object(key, value) {
        return function (item) {
            return _extends({}, item, _defineProperty({}, key, value));
        };
    },
    array: function array(key, value) {
        return function (item) {
            key = key < 0 ? key + item.length : key;
            var clone = [].concat(_toConsumableArray(item));
            clone[key] = value;
            return clone;
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/pa/set.js
// module id = 132
// module chunks = 35783957827783 107818501498521